module.exports = __webpack_public_path__ + "static/media/CT_2019_30451.7424365e.png";